import { useData } from 'components/common-form/hooks/useData';
import { useCallback, useState } from 'react';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';
import { LockableAmount } from './LockableAmount';

export function CommonLockableAmountField({ node, tabIndex, ...props }: ProductNodeBuilderProps) {
  const [value, setValue] = useData<number>(node.id);
  const [isLockedValue, setIsLockedValue] = useState<boolean | null>(null);
  const onLockChanged = useCallback(
    (locked: boolean) => {
      setIsLockedValue(locked);
      if (locked) {
        setValue(null);
      }
    },
    [setValue],
  );
  return (
    <LockableAmount
      node={node}
      value={value}
      isLockedValue={isLockedValue}
      onLockChanged={onLockChanged}
      onValueChanged={setValue}
      tabIndex={tabIndex}
      {...props}
    />
  );
}
